webpackJsonp([38],{

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo_sdg1.c1da66f.svg";

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjJweCIgaGVpZ2h0PSIyMnB4IiB2aWV3Qm94PSIwIDAgMjIgMjIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU3LjEgKDgzMDg4KSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5QYXNzd29yZF8wPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlBhc3N3b3JkXzAiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJJY19leWUxIiBmaWxsPSIjNUM2MTY4Ij4KICAgICAgICAgICAgPGcgaWQ9IkV5ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC45NTQ1NDUsIDQuNTAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNOS41NDU0NTQ1NSwwIEMzLjI4MjY4MTgyLDAgMCw0LjgzMiAwLDUuNiBDMCw2LjM2NiAzLjI4MjY4MTgyLDExLjIgOS41NDU0NTQ1NSwxMS4yIEMxNS44MDcyNzI3LDExLjIgMTkuMDkwOTA5MSw2LjM2NiAxOS4wOTA5MDkxLDUuNiBDMTkuMDkwOTA5MSw0LjgzMiAxNS44MDcyNzI3LDAgOS41NDU0NTQ1NSwwIEw5LjU0NTQ1NDU1LDAgWiBNOS41NDU0NTQ1NSw5LjkwNyBDNy4yMDIwNDU0NSw5LjkwNyA1LjMwMjUsNy45NzkgNS4zMDI1LDUuNiBDNS4zMDI1LDMuMjIxIDcuMjAyMDQ1NDUsMS4yOTEgOS41NDU0NTQ1NSwxLjI5MSBDMTEuODg4ODYzNiwxLjI5MSAxMy43ODc0NTQ1LDMuMjIxIDEzLjc4NzQ1NDUsNS42IEMxMy43ODc0NTQ1LDcuOTc5IDExLjg4ODg2MzYsOS45MDcgOS41NDU0NTQ1NSw5LjkwNyBMOS41NDU0NTQ1NSw5LjkwNyBaIE05LjU0NTQ1NDU1LDUuNiBDOS4xNTY5NTQ1NSw1LjE1MyAxMC4xNzgzMTgyLDMuNDQ2IDkuNTQ1NDU0NTUsMy40NDYgQzguMzczMjcyNzMsMy40NDYgNy40MjM1LDQuNDExIDcuNDIzNSw1LjYgQzcuNDIzNSw2Ljc4OSA4LjM3MzI3MjczLDcuNzU0IDkuNTQ1NDU0NTUsNy43NTQgQzEwLjcxNjY4MTgsNy43NTQgMTEuNjY3NDA5MSw2Ljc4OSAxMS42Njc0MDkxLDUuNiBDMTEuNjY3NDA5MSw1LjA1MyA5Ljg3NTcyNzI3LDUuOTc5IDkuNTQ1NDU0NTUsNS42IEw5LjU0NTQ1NDU1LDUuNiBaIiBpZD0iU2hhcGUiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Content__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Utility__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_GoogleAnalytics__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SignupForm",
  data: function data() {
    return {
      width: "30%",
      subscribername: "",
      userEmail: "",
      password: "",
      confirmpassword: "",
      iconEyeOpenPath: __webpack_require__(253),
      iconEyeClosePath: __webpack_require__(254),
      showLoading: false,
      formError: "",
      // error
      subscribernameError: "",
      userEmailError: "",
      passwordError: "",
      confirmPasswordError: ""
    };
  },

  props: ["closePopupCB", "previousActionData"],
  components: {
    Popup: function Popup() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 70));
    },
    Loading: function Loading() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 170));
    },
    FormError: function FormError() {
      return __webpack_require__.e/* import() */(21/* duplicate */).then(__webpack_require__.bind(null, 188));
    }
  },
  created: function created() {
    var _this = this;

    // signupError
    __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$on("signupError", function (error) {
      var GA = {
        "Event Label": "Failure",
        Status: "FAILURE",
        ErrorCode: error.Code,
        ErrorMessage: error.Message
      };
      _this.signUpEvent(GA);
      //
      _this.formError = error.Message;
      _this.$refs.signUpBtnSubmit.disabled = false;
      _this.$refs.loginBtn.disabled = false;
      _this.showLoading = false;
    });
    //signupSuccess
    __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$on("signupSuccess", function () {
      var GA = {
        "Event Label": "Success",
        Status: "SUCCESS",
        Name: _this.subscribername,
        Mode: "EMAIL"
      };
      _this.signUpEvent(GA);
      //
      // console.log("loginSuccess-previousActionData", this.previousActionData);
      if (_this.previousActionData) {
        if (_this.previousActionData.button && _this.previousActionData.button === "LIKEDISLIKE") {
          _this.updateLikeDislikeToFire(_this.previousActionData.content, _this.previousActionData.action);
        } else {
          switch (_this.previousActionData.popup) {
            case "PaymentPopup":
              _this.actListTicket().then(function (response) {
                var showPaymentPopup = true;
                if (response.length > 0) {
                  var index = response.findIndex(function (ele) {
                    return ele.contentid === _this.previousActionData.contentid;
                  });
                  if (index > -1) {
                    showPaymentPopup = false;
                  }
                }
                if (showPaymentPopup) {
                  var data = {
                    contentid: _this.previousActionData.contentid
                  };
                  if (_this.previousActionData.coupon) {
                    data.coupon = _this.previousActionData.coupon;
                  }
                  __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$emit("PaymentPopup", data);
                }
              });
              break;
            case "sharedPopup":
              if (_this.previousActionData.action && _this.previousActionData.content) {
                _this.updateLikeDislikeToFire(_this.previousActionData.content, _this.previousActionData.action);
              }
              __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$emit("sharedPopup", _this.previousActionData.content ? _this.previousActionData.content.contentid : _this.previousActionData.contentid);
              break;
          }
        }
      }
      // Hide the popup
      _this.closePopupCB();
    });
  },

  watch: {
    formError: function formError(value) {
      var _this2 = this;

      if (value) {
        setTimeout(function () {
          _this2.formError = null;
        }, 5000);
      }
    },
    subscribername: function subscribername() {
      if (this.subscribernameError) {
        this.subscribernameError = null;
        document.getElementById("subscribername").classList.remove("formError");
      }
    },
    userEmail: function userEmail() {
      if (this.userEmailError) {
        this.userEmailError = null;
        document.getElementById("userEmail").classList.remove("formError");
      }
    },
    password: function password() {
      if (this.passwordError) {
        this.passwordError = null;
        document.getElementById("password").classList.remove("formError");
      }
    },
    confirmpassword: function confirmpassword() {
      if (this.confirmPasswordError) {
        this.confirmPasswordError = null;
        document.getElementById("confirmpassword").classList.remove("formError");
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    // Stop listening
    __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$off("signupSuccess");
    __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$off("signupError");
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(["actListTicket"]), {
    openLoginPopup: function openLoginPopup() {
      // open Login Popup
      __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$emit("LoginPopup", this.previousActionData);
      // Hide the popup
      this.closePopupCB();
    },
    closePopup: function closePopup() {
      // Hide the popup
      this.closePopupCB();
    },
    signupCB: function signupCB() {
      if (!this.isFormValid()) return;
      //
      this.showLoading = true;
      //
      this.$refs.signUpBtnSubmit.disabled = true;
      this.$refs.loginBtn.disabled = true;

      //
      if (!this.checkCookie()) {
        __WEBPACK_IMPORTED_MODULE_4__main__["EventBus"].$emit("registerUser", {
          subscribername: this.subscribername,
          email: this.userEmail,
          password: this.password
        }, "S");
      } else {
        window.location.reload();
      }
    },
    isFormValid: function isFormValid() {
      return this.validateName() && this.validateEmailInput() && this.validatePassword() && this.validateConfirmPassword();
    },
    validateName: function validateName() {
      // let minChar = 3;
      var maxChar = 64;
      if (!this.subscribername) {
        this.subscribernameError = "Please enter Name";
        document.getElementById("subscribername").classList.add("formError");
        return false;
      } else if (!this.validateInputName(this.subscribername)) {
        this.subscribernameError = "Please enter valid Name";
        document.getElementById("subscribername").classList.add("formError");
        return false;
      }
      // else if (this.subscribername.length < minChar) {
      //   this.subscribernameError = `Name should contain atleast ${minChar} characters`;
      //   document.getElementById("subscribername").classList.add("formError");
      //   return false;
      // }
      else if (this.subscribername.length > maxChar) {
          this.subscribernameError = "Name should be less than " + maxChar + " characters";
          document.getElementById("subscribername").classList.add("formError");
          return false;
        } else {
          this.subscribernameError = "";
          document.getElementById("subscribername").classList.remove("formError");
          return true;
        }
    },
    validateEmailInput: function validateEmailInput() {
      var maxChar = 128;
      // validateEmail method was defined in Utility mixin
      if (!this.userEmail) {
        this.userEmailError = "Please enter Email";
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else if (!this.validateEmail(this.userEmail)) {
        this.userEmailError = "Invalid Email Id.Please enter in format xxx@yyy.com";
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else if (this.userEmail.length > maxChar) {
        this.userEmailError = "E-mail must be less than " + maxChar + " characters";
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else {
        this.userEmailError = "";
        document.getElementById("userEmail").classList.remove("formError");
        return true;
      }
    },
    validatePassword: function validatePassword() {
      var minChar = 8;
      var maxChar = 16;
      if (!this.password) {
        this.passwordError = "Please enter Password";
        document.getElementById("password").classList.add("formError");
        return false;
      } else if (this.password.length < minChar || this.password.length > maxChar) {
        this.passwordError = "Password should be " + minChar + " - " + maxChar + " characters long";
        document.getElementById("password").classList.add("formError");
        return false;
      }
      // else if (this.password.length > maxChar) {
      //   this.passwordError = `Password must be less than ${maxChar} characters`;
      //   document.getElementById("password").classList.add("formError");
      //   return false;
      // }
      // else if (!this.validateInputPassword(this.password)) {
      //   this.passwordError = `Password should contain atleast One special charcter, One upper case and One number.`;
      //   document.getElementById('password').classList.add('formError');
      //   return false;
      // }
      else {
          this.passwordError = "";
          document.getElementById("password").classList.remove("formError");
          return true;
        }
    },
    validateConfirmPassword: function validateConfirmPassword() {
      var minChar = 8;
      var maxChar = 16;

      if (!this.confirmpassword) {
        this.confirmPasswordError = "Please enter Confirm Password";
        document.getElementById("confirmpassword").classList.add("formError");
        return false;
      } else if (this.confirmpassword.length < minChar || this.confirmpassword.length > maxChar) {
        this.confirmPasswordError = "Password should be " + minChar + " - " + maxChar + " characters long";
        document.getElementById("confirmpassword").classList.add("formError");
        return false;
      }
      // else if (this.confirmpassword.length > maxChar) {
      //   this.confirmPasswordError = `Password must be less than ${maxChar} characters`;
      //   document.getElementById("confirmpassword").classList.add("formError");
      //   return false;
      // }
      else if (this.confirmpassword != this.password) {
          this.confirmPasswordError = "Confirm Password doesn't match with Password";
          document.getElementById("confirmpassword").classList.add("formError");
          return false;
        } else {
          this.confirmPasswordError = "";
          document.getElementById("confirmpassword").classList.remove("formError");
          return true;
        }
    },
    toggleInputMode: function toggleInputMode(_event) {
      // Get the target element
      var target = _event.target;
      // Get the container div of the input field
      var parentNode = target.parentNode.parentNode;
      // Get the input element from it
      var inputElm = parentNode.getElementsByTagName("input")[0];
      // Now change the type to text if password or vice-versa and change the icon
      if (inputElm.type === "password") {
        inputElm.type = "text";
        // Change the icon
        target.src = this.iconEyeClosePath;
      } else {
        inputElm.type = "password";
        // Change the icon
        target.src = this.iconEyeOpenPath;
      }
    }
  }),
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Content__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Utility__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_GoogleAnalytics__["a" /* default */]]
});

/***/ }),

/***/ 380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__ = __webpack_require__(320);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45e1737e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__ = __webpack_require__(383);
function injectStyle (ssrContext) {
  __webpack_require__(381)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45e1737e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45e1737e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(382);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("10795fce", content, true, {});

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, "input[data-v-45e1737e]::-ms-clear,input[data-v-45e1737e]::-ms-reveal{display:none}input[data-v-45e1737e]:invalid{outline:none}input[type=email][data-v-45e1737e],input[type=password][data-v-45e1737e],input[type=search][data-v-45e1737e],input[type=text][data-v-45e1737e],textarea[data-v-45e1737e]{font-size:18px;font-weight:400}.session-exp-popup[data-v-45e1737e]{padding:20px}.login-logo[data-v-45e1737e]{text-align:center}.login-logo img[data-v-45e1737e]{width:25%;margin:5% 0}.signup-form[data-v-45e1737e]{margin:0 10%}.vlt-input-group[data-v-45e1737e]{margin:0 0 10px}.vlt-signup[data-v-45e1737e]{padding:20px}.vlt-signup[data-v-45e1737e] :first-child{margin-left:25%}.vlt-signup[data-v-45e1737e] :nth-child(2){margin-left:10px;cursor:pointer;font-weight:600}.vlt-signup p[data-v-45e1737e]{float:left;color:#212121;font-family:ProximanovaRegular;font-size:16px;line-height:18px}.login-label[data-v-45e1737e]{color:#212121;font-family:ProximanovaBold;font-size:16px;line-height:20px}.signup-error-message[data-v-45e1737e]{color:#d0021b;font-family:ProximanovaRegular;font-size:16px;font-weight:100;line-height:18px;margin-top:5px}.login[data-v-45e1737e]{color:#4558dd!important;font-family:ProximanovaBold;font-size:18px;line-height:18px;font-weight:700;border:none;background:transparent}.login[data-v-45e1737e]:hover{text-decoration:underline}@media only screen and (max-width:600px){.session-exp-popup[data-v-45e1737e]{padding:10px}.vlt-input-group[data-v-45e1737e]{margin:0 0 5px}.vlt-input-group label[data-v-45e1737e]{font-size:14px}.login-header[data-v-45e1737e]{font-size:20px}.vlt-signup-divd p[data-v-45e1737e]{margin:7px 0;font-size:16px}input[type=email][data-v-45e1737e],input[type=password][data-v-45e1737e],input[type=text][data-v-45e1737e]{height:30px}.vlt-lgn-fgtpwd[data-v-45e1737e]{margin-bottom:8px;font-size:12px}button[data-v-45e1737e]{padding:8px;font-size:15px}.vlt-signup[data-v-45e1737e]{padding:10px;text-align:center}.vlt-signup[data-v-45e1737e] :first-child,.vlt-signup[data-v-45e1737e] :nth-child(2){margin-left:0}.vlt-signup p[data-v-45e1737e]{display:inline;text-align:center;float:none}}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/Popups/SignUp.vue"],"names":[],"mappings":"AACA,qEAAqE,YAAY,CAChF,AACD,+BAA+B,YAAY,CAC1C,AACD,yKAAiL,eAAe,eAAe,CAC9M,AACD,oCAAoC,YAAY,CAC/C,AACD,6BAA6B,iBAAiB,CAC7C,AACD,iCAAiC,UAAU,WAAW,CACrD,AACD,8BAA8B,YAAkB,CAC/C,AACD,kCAAkC,eAAiB,CAClD,AACD,6BAA6B,YAAY,CACxC,AACD,0CAA2C,eAAe,CACzD,AACD,2CAA2C,iBAAiB,eAAe,eAAe,CACzF,AACD,+BAA+B,WAAW,cAAc,+BAAiC,eAAe,gBAAgB,CACvH,AACD,8BAA8B,cAAc,4BAA8B,eAAe,gBAAgB,CACxG,AACD,uCAAuC,cAAc,+BAAiC,eAAe,gBAAgB,iBAAiB,cAAc,CACnJ,AACD,wBAAwB,wBAAyB,4BAA8B,eAAe,iBAAiB,gBAAiB,YAAY,sBAAsB,CACjK,AACD,8BAA8B,yBAAyB,CACtD,AACD,yCACA,oCAAoC,YAAY,CAC/C,AACD,kCAAkC,cAAgB,CACjD,AACD,wCAAwC,cAAc,CACrD,AACD,+BAA+B,cAAc,CAC5C,AACD,oCAAoC,aAAa,cAAc,CAC9D,AACD,2GAAiH,WAAW,CAC3H,AACD,iCAAiC,kBAAkB,cAAc,CAChE,AACD,wBAAwB,YAAY,cAAc,CACjD,AACD,6BAA6B,aAAa,iBAAiB,CAC1D,AAGD,qFAA2C,aAAc,CACxD,AACD,+BAA+B,eAAe,kBAAkB,UAAU,CACzE,CACA","file":"SignUp.vue","sourcesContent":["\ninput[data-v-45e1737e]::-ms-clear,input[data-v-45e1737e]::-ms-reveal{display:none\n}\ninput[data-v-45e1737e]:invalid{outline:none\n}\ninput[type=\"text\"][data-v-45e1737e],input[type=\"search\"][data-v-45e1737e],input[type=\"password\"][data-v-45e1737e],input[type=\"email\"][data-v-45e1737e],textarea[data-v-45e1737e]{font-size:18px;font-weight:400\n}\n.session-exp-popup[data-v-45e1737e]{padding:20px\n}\n.login-logo[data-v-45e1737e]{text-align:center\n}\n.login-logo img[data-v-45e1737e]{width:25%;margin:5% 0\n}\n.signup-form[data-v-45e1737e]{margin:0 10% 0 10%\n}\n.vlt-input-group[data-v-45e1737e]{margin:0 0 10px 0\n}\n.vlt-signup[data-v-45e1737e]{padding:20px\n}\n.vlt-signup[data-v-45e1737e] :nth-child(1){margin-left:25%\n}\n.vlt-signup[data-v-45e1737e] :nth-child(2){margin-left:10px;cursor:pointer;font-weight:600\n}\n.vlt-signup p[data-v-45e1737e]{float:left;color:#212121;font-family:\"ProximanovaRegular\";font-size:16px;line-height:18px\n}\n.login-label[data-v-45e1737e]{color:#212121;font-family:\"ProximanovaBold\";font-size:16px;line-height:20px\n}\n.signup-error-message[data-v-45e1737e]{color:#d0021b;font-family:\"ProximanovaRegular\";font-size:16px;font-weight:100;line-height:18px;margin-top:5px\n}\n.login[data-v-45e1737e]{color:#4558dd !important;font-family:\"ProximanovaBold\";font-size:18px;line-height:18px;font-weight:bold;border:none;background:transparent\n}\n.login[data-v-45e1737e]:hover{text-decoration:underline\n}\n@media only screen and (max-width: 600px){\n.session-exp-popup[data-v-45e1737e]{padding:10px\n}\n.vlt-input-group[data-v-45e1737e]{margin:0 0 5px 0\n}\n.vlt-input-group label[data-v-45e1737e]{font-size:14px\n}\n.login-header[data-v-45e1737e]{font-size:20px\n}\n.vlt-signup-divd p[data-v-45e1737e]{margin:7px 0;font-size:16px\n}\ninput[type=\"email\"][data-v-45e1737e],input[type=\"password\"][data-v-45e1737e],input[type=\"text\"][data-v-45e1737e]{height:30px\n}\n.vlt-lgn-fgtpwd[data-v-45e1737e]{margin-bottom:8px;font-size:12px\n}\nbutton[data-v-45e1737e]{padding:8px;font-size:15px\n}\n.vlt-signup[data-v-45e1737e]{padding:10px;text-align:center\n}\n.vlt-signup[data-v-45e1737e] :nth-child(1){margin-left:0%\n}\n.vlt-signup[data-v-45e1737e] :nth-child(2){margin-left:0%\n}\n.vlt-signup p[data-v-45e1737e]{display:inline;text-align:center;float:none\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popup',{attrs:{"width":_vm.width,"closePopupEvent":_vm.closePopupCB}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h6',[_vm._v("Create Your Account")])]),_vm._v(" "),_c('div',{staticClass:"session-exp-popup"},[_c('div',{staticClass:"login-logo"},[_c('img',{attrs:{"src":__webpack_require__(202),"alt":"logo"}})]),_vm._v(" "),_c('FormError',{directives:[{name:"show",rawName:"v-show",value:(_vm.formError),expression:"formError"}],attrs:{"message":_vm.formError}}),_vm._v(" "),_c('div',{staticClass:"signup-form"},[_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.signupCB($event)}}},[_c('input',{staticStyle:{"display":"none"},attrs:{"autocomplete":"false","name":"hidden","type":"text"}}),_vm._v(" "),_c('div',{staticClass:"vlt-signup-form"},[_c('div',{staticClass:"vlt-input-group"},[_c('label',{staticClass:"login-label"},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subscribername),expression:"subscribername"}],ref:"subscribername",attrs:{"id":"subscribername","type":"text","placeholder":"","maxlength":"40"},domProps:{"value":(_vm.subscribername)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subscribername=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"signup-error-message"},[_vm._v(_vm._s(_vm.subscribernameError))])]),_vm._v(" "),_c('div',{staticClass:"vlt-input-group"},[_c('label',{staticClass:"login-label"},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userEmail),expression:"userEmail"}],attrs:{"id":"userEmail","type":"text","placeholder":"","maxlength":"64"},domProps:{"value":(_vm.userEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userEmail=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"signup-error-message"},[_vm._v(_vm._s(_vm.userEmailError))])]),_vm._v(" "),_c('div',{staticClass:"vlt-input-group input-ico"},[_c('label',{staticClass:"login-label"},[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"vlt-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"id":"password","type":"password","placeholder":"","maxlength":"16"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"signup-error-message"},[_vm._v(_vm._s(_vm.passwordError))]),_vm._v(" "),_c('span',{staticClass:"ico-img",staticStyle:{"cursor":"pointer"}},[_c('img',{attrs:{"src":_vm.iconEyeOpenPath,"alt":"eye img"},on:{"click":_vm.toggleInputMode}})])])]),_vm._v(" "),_c('div',{staticClass:"vlt-input-group input-ico"},[_c('label',{staticClass:"login-label"},[_vm._v("Confirm Password")]),_vm._v(" "),_c('div',{staticClass:"vlt-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmpassword),expression:"confirmpassword"}],attrs:{"id":"confirmpassword","type":"password","placeholder":"","maxlength":"16"},domProps:{"value":(_vm.confirmpassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirmpassword=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"signup-error-message"},[_vm._v(_vm._s(_vm.confirmPasswordError))]),_vm._v(" "),_c('span',{staticClass:"ico-img",staticStyle:{"cursor":"pointer"}},[_c('img',{attrs:{"src":_vm.iconEyeOpenPath,"alt":"eye img"},on:{"click":_vm.toggleInputMode}})])])]),_vm._v(" "),_c('div',{staticClass:"vlt-signup-btns",staticStyle:{"margin-top":"10%"}},[_c('button',{ref:"signUpBtnSubmit",staticClass:"btn-lg-primary",attrs:{"type":"submit","aria-label":"Signup"}},[_vm._v("Signup")])])])])]),_vm._v(" "),_c('Loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}]}),_vm._v(" "),_c('div',{staticClass:"vlt-signup"},[_c('p',[_vm._v("Already onboard?")]),_vm._v(" "),_c('button',{ref:"loginBtn",staticClass:"login",attrs:{"aria-label":"Login"},on:{"click":_vm.openLoginPopup}},[_vm._v("Login")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/38.01f86970465f2032688b.js